import apiClient from "../api-client";
import { handleApiError } from "../../utils/handle-api-error";

export const updateMessage = async (data: any): Promise<any> => {
  try {
    const response = await apiClient.put<any>(`/message`, data);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const deleteMessage = async (
  messageId: string,
  data: any
): Promise<any> => {
  try {
    const response = await apiClient.delete<any>(`/message/${messageId}`, data);
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const updateMessageResponseTime = async (data: any): Promise<any> => {
  try {
    const res = await apiClient.patch<any>(`/message_response_time`, data);
    return res?.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
